// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-make-actual-confirm {
  width: 490px;
}
.dialog-make-actual-confirm__controls {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.dialog-make-actual-confirm__button + .dialog-make-actual-confirm__button {
  margin-left: 12px;
}
.dialog-make-actual-confirm__text-selected {
  font-weight: bold;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.dialog-make-actual-confirm__body {
  display: flex;
  align-items: center;
}
.dialog-make-actual-confirm__icon {
  margin-right: 5px;
  color: var(--g-color-text-warning);
}
.dialog-make-actual-confirm__message {
  padding: 0 12px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryDialogues/DialogMakeActualConfirm/DialogMakeActualConfirm.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,yBAAA;AACR;AAEI;EACI,iBAAA;AAAR;AAGI;EACI,iBAAA;EACA,qBAAA;EACA,qBAAA;AADR;AAII;EACI,aAAA;EACA,mBAAA;AAFR;AAKI;EACI,iBAAA;EACA,kCAAA;AAHR;AAMI;EACI,eAAA;AAJR","sourcesContent":[".dialog-make-actual-confirm {\n  width: 490px;\n}\n.dialog-make-actual-confirm__controls {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n}\n.dialog-make-actual-confirm__button + .dialog-make-actual-confirm__button {\n  margin-left: 12px;\n}\n.dialog-make-actual-confirm__text-selected {\n  font-weight: bold;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.dialog-make-actual-confirm__body {\n  display: flex;\n  align-items: center;\n}\n.dialog-make-actual-confirm__icon {\n  margin-right: 5px;\n  color: var(--g-color-text-warning);\n}\n.dialog-make-actual-confirm__message {\n  padding: 0 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
